import { createFileRoute } from '@tanstack/react-router'

import SelectStorePage from '@/views/stores/pages/select-store.page'

export const Route = createFileRoute('/_layout/stores/select-store')({
  component: SelectStorePage,
})
